import React from 'react';
import {Entries} from '@2020-contest-web/components/src/components';
import StepBox from '@2020-contest-web/components/src/components/StepBox';
import { useResource } from 'retil';
import { newsList } from '../../resources/news';
import { Hero, Footer } from '../../components';
import { Link } from 'react-navi';
import {Entry} from "@2020-contest-web/components/src/types";
import classNames from "classnames";
import {entryList} from "../../resources";
import {EntryCard} from "../../components/card";

export function TopApp() {
  const [news] = useResource(newsList);
  const [entries] = useResource(entryList);
  return (
    <main className="TopApp">
      <Hero />
      {/* FINALIST */}
      <section id="finalist" className="section">
        <div className="container">
          <div className="is-margin-bottom-3">
            <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">Finalist</h2>
          </div>
          <div className="columns is-multiline is-mobile is-margin-bottom-3">
            <Entries state={entries} noshuffle>
              {(list: Entry[]) =>
                  list.map((item: Entry) => (
                      <div
                          className={classNames('column is-4-tablet is-6-mobile')}
                          key={item.entry_id}
                      >
                        <EntryCard onlive={false} entry={item} href={`/profiles/${item.entry_id}`} />
                      </div>
                  ))
              }
            </Entries>
          </div>
        </div>
      </section>

      <section id="about" className="section as-about-section">
        <div className="container" style={{ maxWidth: 720 }}>
          <div className="is-margin-bottom-3">
            <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">About</h2>
          </div>
          <p className="notification is-margin-bottom-3 is-size-7-mobile" style={{ margin: '0 auto' }}>
            Sophian's
            Contest（ソフィアンズコンテスト）は、上智大学で長年続いていた「ミス・ミスターソフィアコンテスト」を廃止し、
            <strong className="has-text-marker">2020年度から新設されたコンテストです。</strong>
            <br />
            <br />
            全上智生から選ばれた候補者が、ソフィア祭までの活動期間の中で
            <strong className="has-text-marker">自身の魅力と社会課題を発信するインフルエンサーとしての活躍</strong>
            を競います。
            <br />
            <br />
            このコンテストでは、従来のミスミスターが持っていた課題を理解した上で、見える上智生として
            <strong className="has-text-marker">上智大学の魅力を伝え、社会で活躍する人財を輩出すること</strong>
            を目指しています。
            <br />
            <br />
            コロナウイルスの影響もあり難しい面も多々ありますが、上智大学で長く続く新たなコンテストとなるよう運営一同活動していく所存であります。変わらずのご支援、ご協力をどうぞよろしくお願い致します。
          </p>
          <div className="theme-box has-text-centered">
            <div>
              <figure className="image is-margin-bottom-3">
                <img src="/img/bg/theme@2x.jpg" />
              </figure>
              <div className="is-margin-bottom-2">
                <p className="has-text-weight-bold is-size-7 is-margin-bottom-0-5">コンテストテーマ</p>
                <h3 className="is-size-3 is-size-4-mobile">
                  <figure className="image as-theme-logo" style={{ maxWidth: 240, margin: '0 auto' }}>
                    <img src="data:image/svg+xml,%3Csvg width='435' height='206' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect x='.8' y='.8' width='26.4' height='14.4' rx='2'/%3E%3Cpath d='M120.997333,90.9834645 C123.349333,90.7249686 126.681333,91.5347661 126.681333,94.4747661 C126.681333,97.0227661 120.605333,105.334547 119.037333,109.426878 C130.993333,95.764857 141.185333,89.1567081 146.085333,88.618175 C150.593333,88.1227246 153.533333,90.9356047 153.533333,97.4036047 C153.533333,108.379605 138.441333,138.262287 115.901333,140.739539 C113.157333,141.041117 109.237333,139.707944 108.061333,138.661192 C104.925333,142.925853 94.733333,172.858002 94.733333,186.774002 C94.733333,189.322002 95.517333,191.587837 95.517333,194.331837 C95.517333,196.683837 93.165333,200.470332 90.225333,200.793452 C87.285333,201.116572 84.737333,199.436609 84.737333,194.144609 C84.737333,177.484609 93.557333,149.27125 98.261333,135.818258 C102.425057,123.910405 107.663718,110.963037 110.579188,104.553656 C106.313019,105.736562 99.9881815,107.806656 90.748,111.752009 C90.944,112.906467 90.944,113.886467 90.944,115.062467 C90.944,152.890467 47.236,202.382183 21.756,205.182555 C8.624,206.625823 0,199.537642 0,187.385642 C0,174.449642 10.584,155.84241 37.24,133.90079 C50.764,122.810439 64.092,115.661629 76.048,110.035608 C72.324,107.504893 66.444,106.583133 60.76,107.207831 C53.312,108.026402 46.06,110.391431 38.024,111.274625 C31.948,111.942406 24.108,108.688059 24.108,99.8680589 C24.108,73.2120589 76.832,35.2734428 101.92,32.5161533 C108.388,31.8052896 115.64,34.9282606 115.64,42.3762606 C115.64,52.5682606 96.824,73.2562277 92.708,77.8245955 C89.964,80.6741741 87.808,82.6751286 84.672,83.0197898 C81.34,83.3859923 79.576,81.6198642 79.576,78.2878642 C79.576,74.9558642 81.732,73.3469097 87.808,68.7591286 C93.492,64.6064302 104.664,50.6385748 104.664,46.1305748 C104.664,43.7785748 103.684,41.5342814 99.764,41.9651079 C82.516,43.8607444 36.064,78.7580381 36.064,97.3780381 C36.064,99.5340381 36.848,101.603873 40.572,101.194588 C48.216,100.354476 55.86,98.3383644 65.464,97.2828396 C75.068,96.2273147 83.3,100.026579 87.612,105.23667 C102.170689,99.205696 111.363237,96.447557 115.395954,95.4954053 C117.037457,93.0227213 118.839167,91.2206571 120.997333,90.9834645 Z M231.867999,86.6382557 C233.435999,81.3699251 234.807999,78.2791359 237.943999,77.9344747 C240.491999,77.6544375 242.255999,78.8325656 242.255999,80.9885656 C242.255999,82.3605656 240.687999,86.8448961 238.923999,91.5467681 C246.959999,82.4315738 254.211999,75.3625448 259.307999,74.8024704 C263.619999,74.3285613 266.755999,76.5319001 266.755999,81.4319001 C266.755999,88.0959001 265.187999,93.9522307 259.503999,94.5769291 C257.347999,94.8138836 255.583999,93.4397555 255.583999,91.0877555 C255.583999,89.3237555 256.955999,86.6249663 256.955999,85.6449663 C256.955999,85.0569663 256.759999,84.6865076 255.779999,84.7942142 C253.231999,85.0742514 240.687999,98.4088961 234.219999,108.52776 C232.455999,111.269632 230.299999,115.818586 228.535999,120.324458 C226.967999,124.416789 225.203999,128.334661 224.027999,128.463909 C221.675999,128.722405 218.931999,126.867983 218.931999,124.123983 C218.931999,122.290789 220.915825,115.988509 223.437648,109.472555 C214.759489,119.266316 204.405995,128.660459 196.914666,129.483792 C190.446666,130.194655 187.310666,126.031317 187.310666,120.543317 C187.310666,118.387317 187.506666,116.405775 187.702666,113.640234 C182.018666,119.948932 168.690666,134.741742 159.870666,135.711102 C157.322666,135.991139 153.206666,132.915507 153.206666,127.819507 C153.206666,107.631507 175.942666,85.5327134 190.838666,83.8955728 C193.974666,83.5509116 196.914666,85.1877918 198.874666,87.3243785 C199.462666,87.2597546 201.618666,83.1028 204.558666,82.7796801 C208.282666,82.370395 210.438666,84.2894404 210.438666,87.0334404 C210.438666,90.3654404 203.382666,99.5689281 201.030666,104.923424 C199.070666,109.058837 197.502666,113.543168 197.502666,116.287168 C197.502666,118.247168 198.286666,120.317003 200.050666,120.123131 C206.518666,119.412267 217.494666,106.445953 224.550666,97.2424651 C226.545794,94.5292815 228.681955,91.6595639 230.600247,90.7065431 C231.151886,89.0744141 231.584009,87.6918317 231.867999,86.6382557 Z M347.246665,115.117596 C339.406665,115.979249 332.546665,111.049196 332.546665,101.641196 C332.546665,100.260917 332.638963,98.7713071 332.814552,97.1886023 C324.729993,107.530382 314.681021,118.108714 304.061332,119.275868 C293.085332,120.482182 288.185332,109.064715 288.185332,104.752715 C288.185332,102.988715 288.773332,101.748091 291.909332,100.22743 C296.809332,97.9248971 310.529332,87.9890045 310.529332,82.5010045 C310.529332,80.9330045 309.353332,80.4742524 308.373332,80.581959 C306.217332,80.8189136 297.789332,87.2331905 287.597332,99.5253393 C281.129332,107.488203 276.621332,113.667653 276.621332,117.783653 C276.621332,120.723653 273.681332,123.790773 271.329332,124.049269 C269.173332,124.286224 265.449332,123.519509 265.449332,118.227509 C265.449332,110.191509 283.285332,61.3872485 292.497332,42.3428062 C303.081332,20.5995748 314.841332,7.74309533 325.033332,6.62294649 C328.953332,6.19212001 332.677332,9.70283486 332.677332,13.4268349 C332.677332,18.9148349 329.933332,30.7804134 317.389332,49.9950581 C308.569332,63.1164177 296.809332,74.9928971 285.441332,85.6502939 C284.657332,86.5204592 281.717332,93.1155791 280.737332,96.3592857 C295.829332,78.6286037 306.805332,71.5422896 313.273332,70.8314259 C316.605332,70.4652234 320.525332,72.9743969 320.525332,77.6783969 C320.525332,89.2423969 304.061332,100.263868 296.809332,104.588897 C297.005332,106.723356 300.729332,111.606071 306.413332,110.981372 C314.841332,110.055095 326.209332,95.0856985 332.873332,85.3372935 C334.02335,83.7733791 335.220226,82.1574559 336.395226,80.8865776 C341.105604,65.0651022 349.356711,46.4484704 356.654665,33.1356129 C368.414665,11.8511335 377.234665,1.27777394 388.406665,0.0499184826 C393.110665,-0.46707329 396.246665,3.10826553 396.246665,7.22426553 C396.246665,12.9082655 393.502665,25.1658441 379.390665,44.7488194 C368.414665,59.8711335 359.006665,69.1371171 348.618665,78.5108072 C345.482665,84.3434684 342.738665,95.4250469 342.738665,99.5410469 C342.738665,104.441047 344.894665,106.948092 348.618665,106.538807 C356.458665,105.677154 370.962665,90.1670963 377.626665,80.4186913 C379.874181,77.3622843 382.300669,74.1072345 384.393064,73.6173064 C391.251679,65.5160306 399.288333,60.9859719 405.915998,60.2575603 C410.031998,59.8051925 414.539998,62.445742 414.539998,66.757742 C414.539998,76.949742 398.075998,90.3232132 385.139998,94.6849406 C382.591998,95.5529778 381.807998,97.0111431 381.807998,98.3831431 C381.807998,99.9511431 383.571998,103.481271 387.295998,103.071986 C403.759998,101.262515 416.891998,84.7272461 423.947998,75.3277585 C426.299998,72.1292626 428.847998,68.7132254 431.003998,68.4762708 C432.767998,68.2823989 434.139998,69.1116096 434.139998,71.0716096 C434.139998,73.2276096 433.159998,74.7073162 430.807998,77.9058121 C421.595998,90.2862543 405.719998,108.887102 383.963998,111.278189 C377.495998,111.989052 372.007998,107.496209 372.007998,98.8722093 C372.007998,98.5328939 371.926411,98.2514972 371.810319,97.9710557 C363.589366,106.62411 354.288811,114.343631 347.246665,115.117596 Z M22.54,195.688389 C40.572,193.706588 81.144,148.675534 81.144,119.471534 C81.144,118.491534 81.144,117.707534 80.948,116.749075 C69.384,122.136013 54.684,130.611612 41.944,141.615798 C18.424,161.840757 10.388,176.639952 10.388,185.263952 C10.388,192.515952 15.092,196.50696 22.54,195.688389 Z M111.393333,130.062989 C111.981333,130.782365 113.941333,132.134952 116.489333,131.854915 C131.973333,130.15315 143.145333,106.385295 143.145333,101.681295 C143.145333,100.113295 142.165333,99.6330015 140.793333,99.7837908 C135.501333,100.365407 115.117333,120.245704 111.393333,130.062989 Z M188.290666,93.38761 C180.450666,94.249263 163.790666,114.112275 163.790666,123.128275 C163.790666,124.108275 164.574666,124.61011 165.554666,124.502404 C168.494666,124.179284 192.602666,100.557701 192.602666,96.8337009 C192.602666,94.6777009 190.838666,93.1075728 188.290666,93.38761 Z M322.485332,15.3309837 C318.369332,15.7833515 308.373332,29.621959 300.925332,45.3365293 C293.869332,60.224017 290.733332,69.7806782 290.537332,70.3902195 C295.045332,65.582769 303.669332,56.4029508 310.529332,45.6530045 C319.937332,30.8990209 324.445332,20.2115705 324.445332,17.2715705 C324.445332,15.8995705 323.857332,15.1801944 322.485332,15.3309837 Z M384.878665,10.0416623 C382.526665,10.3001582 373.902665,18.1079764 364.102665,36.6290426 C356.066665,51.8202369 353.518665,59.7442741 352.342665,64.1855221 C356.262665,60.6186956 364.494665,51.48196 372.530665,39.8187657 C382.918665,24.9570756 386.838665,15.7062491 386.838665,11.5902491 C386.838665,10.4142491 386.250665,9.89087304 384.878665,10.0416623 Z M403.367998,69.3575975 C398.663998,69.8745892 388.275998,81.4042794 384.551998,87.6935646 C391.607998,85.5460769 404.935998,74.4772669 404.935998,71.1452669 C404.935998,69.9692669 404.543998,69.2283495 403.367998,69.3575975 Z' fill='%23000000' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E" />
                  </figure>
                </h3>
              </div>
              <p className="is-size-7-mobile has-text-centered has-text-weight-bold is-line-height-2-5">
                第一回ソフィアンズコンテストの
                <br />
                テーマは 「sparkle」です。
                <br />
                多様性を尊重するコンテストの理念のもとで
                <br />
                候補者一人ひとりがありのまま輝いてほしい
                <br />
                また変革したこのコンテストが、
                <br />
                ジェンダーをはじめとした社会課題を発信し
                <br />
                広く議論を起こすための
                <br />
                「spark」(火付け)になってほしい
                <br />
                という願いが込められています。
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CONTENTS */}
      <section className="section">
        <div className="container" style={{ maxWidth: 720 }}>
          <div className="is-margin-bottom-3">
            <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">Contents</h2>
          </div>
          <p className="notification has-background-white is-size-7-mobile" style={{ margin: '0 auto' }}>
            Sophian's
            Contest（ソフィアンズコンテスト）は、「自己PR部門」「スピーチ部門」「SDGs部門」で最も多角的に活躍した人がグランプリ、準グランプリに輝きます。
          </p>
          <figure className="image is-margin-bottom-4 is-margin-top-2" style={{ maxWidth: 480, margin: '0 auto' }}>
            <img src="/img/chart.png" />
          </figure>
          <div className="columns is-centered is-multiline">
            <div className="column is-6">
              <StepBox
                className="box"
                style={{ maxWidth: '100%' }}
                src="/img/step1.png"
                alt={'自己PR部門'}
                boxTitle={
                  <>
                    <span className="tag has-text-futura-pt has-text-italic is-size-4">1</span>
                    <br />
                    <br />
                    <strong className="has-text-marker">「自己PR部門」</strong>
                  </>
                }
              >
                <p className="is-size-7-mobile">
                  候補者が自身の魅力を発信する部門。
                  <br />
                  事前web投票と当日の自己PRで受賞者を決定します。
                </p>
              </StepBox>
            </div>
            <div className="column is-6">
              <StepBox
                className="box"
                style={{ maxWidth: '100%' }}
                src="/img/step2.png"
                alt={'スピーチ部門'}
                boxTitle={
                  <>
                    <span className="tag has-text-futura-pt has-text-italic is-size-4">2</span>
                    <br />
                    <br />
                    <strong className="has-text-marker">「スピーチ部門」</strong>
                  </>
                }
              >
                <p className="is-size-7-mobile">
                  本選当日に行われるスピーチでの、スピーチ力を競う部門。
                  <br />
                  本選当日の投票で受賞者を決定します。
                </p>
              </StepBox>
            </div>
            <div className="column is-12">
              <StepBox
                className="box"
                style={{ maxWidth: '100%' }}
                src="/img/step3.png"
                alt={'Step3 SDGs部門'}
                boxTitle={
                  <>
                    <span className="tag has-text-futura-pt has-text-italic is-size-4">3</span>
                    <br />
                    <br />
                    <strong className="has-text-marker">「SDGs部門」</strong>
                  </>
                }
              >
                <p className="is-size-7-mobile">
                  SNS上で自身の問題意識に沿った社会発信を行う部門。
                  <br />
                  今年度は国連が定めた持続可能な開発目標SDGsに基づいた発信を行ないます。部門への参加意欲と社会発信度を合計し受賞者を決定します。
                  <br />
                  <br />
                  持続可能な開発目標（SDGs）とは，2015年9月の国連サミットで採択された「持続可能な開発のための2030アジェンダ」にて記載された2030年までに持続可能でよりよい世界を目指す国際目標です。17のゴール・169のターゲットから構成され，地球上の「誰一人取り残さない（leave
                  no one behind）」ことを誓っています。
                  SDGsは発展途上国のみならず，先進国自身が取り組むユニバーサル（普遍的）なものであり，日本としても積極的に取り組んでいます。(
                  <a
                    href="https://www.mofa.go.jp/mofaj/gaiko/oda/sdgs/about/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    外務省ホームページより引用
                  </a>
                  )
                </p>
                <figure className="image">
                  <img src="/img/bg/sdg_poster.jpg" />
                  <figcaption className="is-size-7 has-text-centered">
                    <a href="https://www.unic.or.jp/activities/economic_social_development/sustainable_development/2030agenda/sdgs_logo/">
                      出典: www.unic.or.jp
                    </a>
                  </figcaption>
                </figure>
              </StepBox>
            </div>
          </div>
        </div>
      </section>
      {/* EXHIBITION */}
      <section className="section" style={{ backgroundColor: '#FDFDFD' }}>
        <div className="container" style={{ maxWidth: 720 }}>
          <div className="is-margin-bottom-3">
            <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">Sophian's Exhibition</h2>
          </div>
          <div className="theme-box has-text-centered is-white">
            <div>
              <figure className="image is-margin-bottom-3">
                <img src="/img/bg/show@2x.jpg" />
              </figure>
              <div className="is-margin-bottom-2">
                <p className="has-text-weight-bold is-size-7 is-margin-bottom-0-5">本選にて全ての審査終了後に開催</p>
              </div>
              <p className="is-size-7-mobile has-text-centered has-text-weight-bold is-line-height-2-5">
                <strong className="has-text-marker">コンテストテーマ「sparkle」x ファッション</strong>をかけて
                <br className="is-hidden-mobile" />
                候補者が最も輝ける服装を披露するファッションショー。
                <br className="is-hidden-mobile" />
                今年度は、リメイクファッションブランドとのコラボを予定しています。
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* OUTLINE */}
      <section className="section">
        <div className="container" style={{ maxWidth: 480 }}>
          <div className="is-margin-bottom-3">
            <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">Outline</h2>
          </div>
          <div className="columns is-mobile is-multiline">
            <div className="column is-5">
              <p className="title is-6">本選実施日時</p>
            </div>
            <div className="column is-7">
              <p className="subtitle is-6">
                2020年11月3日 12:00-15:30<br />
                <span className="is-size-7">
                (オンライン配信  <span className="has-text-marker"><a href="https://www.youtube.com/channel/UCGdArOBiU6fPkR-1jPUG1Mg?view_as=subscriber">視聴URLはこちら</a></span>)
                  </span>
              </p>
            </div>
            <div className="column is-5">
              <p className="title is-6">会場</p>
            </div>
            <div className="column is-7">
              <p className="subtitle is-6">
                上智大学 四谷キャンパス10号館講堂
                <br />
                <span className="has-text-grey-light is-size-7">
                  ※コロナウイルスの影響で変更する可能性がございます。
                </span>
              </p>
            </div>
            <div className="column is-5">
              <p className="title is-6">主催団体名</p>
            </div>
            <div className="column is-7">
              <p className="subtitle is-6">ソフィア祭実行委員会コンテスト局</p>
            </div>
            <div className="column is-5">
              <p className="title is-6">主催代表者名</p>
            </div>
            <div className="column is-7">
              <p className="subtitle is-6">荒尾奈那</p>
            </div>
            <div className="column is-5">
              <p className="title is-6">Twitter</p>
            </div>
            <div className="column is-7">
              <p className="subtitle is-6 has-text-futura-pt has-text-italic">
                <span className="has-text-marker">
                  <a href="https://twitter.com/sophianscontest">@sophianscontest</a>
                </span>
              </p>
            </div>
            <div className="column is-5">
              <p className="title is-6">Instagram</p>
            </div>
            <div className="column is-7">
              <p className="subtitle is-6 has-text-futura-pt has-text-italic">
                <span className="has-text-marker">
                  <a href="https://www.instagram.com/sophianscontest2020">@sophianscontest2020</a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* SPONSOR */}
      <section className="section">
        <div className="container" style={{ maxWidth: 480 }}>
          <div className="is-margin-bottom-3">
            <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">Sponsor</h2>
          </div>
          <div className="columns is-mobile is-multiline is-centered">
            <div className="column is-12 is-margin-bottom-0-75">
              <figure className="image is-padding-left-2 is-padding-right-2">
                <img src="/img/sponsor/rize.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/00_icb.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/01_aimiyuki.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/02_shima.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/03_abiste.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/04_albida.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/05_artisans.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/06_itokanpo.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/07_kadokurakado.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/08_carutena.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/09_lululun.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/10_kosecosmeport.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/11_apagard.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/12_zigen.jpg" />
              </figure>
            </div>
            {/*<div className="column is-4">*/}
            {/*  <figure className="image">*/}
            {/*    <img src="/img/sponsor/13_georgea.jpg" />*/}
            {/*  </figure>*/}
            {/*</div>*/}
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/14_dhc.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/15_teihana.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/16_tripfarm.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/17_nakanoseiyaku.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/18_narisu.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/19_hanagata.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/20_hario.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/21_peachjohn.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/22_anatore.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/23_pratinumbeautiy.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/24_makaibari.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/25_manamana.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/26_marutou.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/27_meishoku.jpg" />
              </figure>
            </div>
            <div className="column is-4">
              <figure className="image">
                <img src="/img/sponsor/28_sumaryu.jpg" />
              </figure>
            </div>
          </div>
        </div>
      </section>
      {/* NEWS */}
      <section id="news" className="section">
        {news.pending || news.data.length === 0 ? null : (
          <div className="container" style={{ maxWidth: 480 }}>
            <div className="is-margin-bottom-3">
              <h2 className="is-size-4 has-text-futura-pt has-text-italic has-text-centered">News</h2>
            </div>
            <div id="news-columns" className="columns is-multiline is-mobile">
              {news.data.map(item => (
                <div key={item.id} className="column is-12">
                  <Link href={`/news/${item.id}`}>
                    <div className="box">
                      <article className="media">
                        <div className="media-content">
                          <div className="content">
                            <p>
                              <strong>{item.title}</strong>
                              <br />
                              <span className="has-text-futura-pt has-text-italic has-text-grey-light is-size-7">
                                {item.publishedAt.toDateString()}
                              </span>
                            </p>
                          </div>
                        </div>
                        {item.image && (
                          <div className="media-right">
                            <figure
                              className="image"
                              style={{
                                width: 110,
                                height: 60,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center center',
                                backgroundColor: '#fafafa',
                                backgroundImage: `url(${item.image.url})`,
                              }}
                            >
                              <img className="is-hidden" width="160" alt="Image" />
                            </figure>
                          </div>
                        )}
                      </article>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
      <Footer />
    </main>
  );
}
